import { fadeIn, transformIn } from "./_animations.mjs";
import { updateButtonStates } from "./_buttons.mjs";

export function createFromTemplate(control, target, template) {

    if (!target) {
        console.warn('target element not found');
        return;
    }

    switch(control) {

        // add custom templates here

        // default (using template element)
        default:
            if (template) {
                const clone = template.content.cloneNode(true);
                target.appendChild(clone);
            } else {
                console.warn('template element not found');
                // todo: assure the content can only be appended once (normally done using once: true on the event listener)
            }
        break;

    }

    return 'createFromTemplate';

}
